"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { enrolledCourses: [] };
    },
    onMount: function () {
        this.fetchCourses();
    },
    fetchCourses: async function () {
        try {
            const {error, message, results} = await Request('/learner/course/enrolled/list');
            if (error)
                console.log('Error Fetching Enrolled Courses: ', message);
            this.state.enrolledCourses = results || [];
        } catch (error) {
            console.log('Error Fetching Enrolled Courses');
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Learner/components/MyCourses.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    EnrolItem_template = require("../../../../components/EnrolItem.marko"),
    EnrolItem_tag = marko_loadTag(EnrolItem_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_attrs0 = {
        "class": "mx-1 my-2",
        id: "my-courses"
      },
    marko_attrs1 = {
        "class": "card"
      },
    marko_attrs2 = {
        "class": "list-group"
      },
    marko_attrs3 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs4 = {
        "class": "text-right"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("section", marko_attrs0, "0", component);

  if (state.enrolledCourses.length) {
    out.be("h6", null, "1", component);

    Locale_tag({
        text: "My Courses"
      }, out, __component, "2");

    out.ee();

    out.be("div", marko_attrs1, "3", component);

    out.be("ul", marko_attrs2, "4", component);

    const displayLimit = state.enrolledCourses.length > 4 ? 4 : state.enrolledCourses.length - 1

    marko_forRange(0, displayLimit, 1, function(index) {
      EnrolItem_tag(state.enrolledCourses[index], out, __component, index);
    });

    if ((state.enrolledCourses.length - 1) > displayLimit) {
      out.be("li", marko_attrs3, "5", component);

      out.be("div", marko_attrs4, "6", component);

      route_link_tag({
          href: "/courses?type=enrolled",
          renderBody: function(out) {
            Locale_tag({
                text: "View all",
                class: "text-primary"
              }, out, __component, "8");
          }
        }, out, __component, "7");

      out.ee();

      out.ee();
    }

    out.ee();

    out.ee();
  }

  out.be("div", null, "9", component);

  route_link_tag({
      href: "/explore",
      class: "btn btn-outline-secondary btn-lg",
      renderBody: function(out) {
        Locale_tag({
            text: "Explore courses"
          }, out, __component, "11");
      }
    }, out, __component, "10");

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
